import { useErrorContext } from "../../context/ErrorContext";
import { Box, Button, Typography } from "@orion/ui";
import { Close, Error } from "@orion/icons";
import { useTranslation } from "react-i18next";

export default function ErrorMessage() {
  const { error, hideError } = useErrorContext();
  const { t } = useTranslation();

  if (!error.visible) {
    return null;
  }

  return (
    <Box
      style={{
        width: "576px",
        margin: "0 auto",
      }}
    >
      <Box
        id="errorMessageToast"
        aria-live="polite"
        tabIndex={0}
        role="alert"
        justifyBetween
        py10
        px8
        bgError20
        gap5
        borderRadius="md"
        border2
        borderSolid
        borderColor="error100"
        style={{
          alignItems: "center",
          display: "flex",
          width: "100%",
          minWidth: "100%",
        }}
      >
        <Box flex gap5 alignContent="center" aria-label={error.message}>
          <Box flex>
            <Error strokeError100 w11 />
          </Box>
          <Typography textError100 style={{ fontWeight: "bold" }}>
            {error.message}
          </Typography>
        </Box>
        <Button
          id="errorMessageToastBtn"
          flex
          variant="ghostDelete"
          onClick={hideError}
          aria-label={t("accessibility.closeErrorMessage")}
        >
          <Close textSuccess100 style={{ height: 24, width: 24 }} />
        </Button>
      </Box>
    </Box>
  );
}
